import { jsx as s } from "react/jsx-runtime";
const r = /youtube\.com\/watch\?v=(.+?)(&t=(.+?))?$/, n = ({ href: e, title: o }) => {
  const [, c, , t] = e.match(r), a = t ? `?start=${t}` : "";
  return /* @__PURE__ */ s(
    "iframe",
    {
      style: { width: "100%", aspectRatio: "2/1" },
      src: `https://www.youtube.com/embed/${c}${a}`,
      title: o,
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      referrerPolicy: "strict-origin-when-cross-origin",
      allowFullScreen: !0
    }
  );
}, u = (e) => r.test(e);
export {
  u as canEmbed,
  n as default
};
